import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const SIZE_ADVISOR_KEY = 'size-advisor';

export const useSizeAdvisorOpenedState = (id?: string) => {
  const UNIQUE_OPENER_KEY = id ? `${SIZE_ADVISOR_KEY}-${id}` : SIZE_ADVISOR_KEY;

  return useOpenedStateManager(UNIQUE_OPENER_KEY);
};
